// src/SEO.js — Reusable SEO component using react-helmet-async

import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://qronetic.site';

const SEO = ({
  title = 'Free QR Code Generator & Scanner Online | Qronetic',
  description = 'Generate and scan QR codes instantly with Qronetic. 100% free QR code generator with custom design, colors, logo support, and fast QR scanner — no app required.',
  keywords = 'free qr code generator, qr code scanner online, create qr code, custom qr code generator, qronetic',
  path = '/',
  image = '/og-image.png',
  type = 'website',
  noindex = false,
}) => {
  const url = `${BASE_URL}${path}`;
  const imageUrl = image.startsWith('http') ? image : `${BASE_URL}${image}`;

  return (
    <Helmet>
      {/* Primary */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content="Qronetic" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};

export default SEO;
